export default __webpack_public_path__ + "static/media/step-backward-solid.0b1f4893.svg";